import styled from 'styled-components'

export const DayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MealsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 40px;
`
export const MealContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  gap: 10px;
`
